import Immutable from 'immutable';

import { ActionTypes } from './actions';

export const initialState = Immutable.fromJS({});

// Maintenance Parts
const setMaintenanceParts = (state, { maintenancePartsData }) => {
  return state.merge({ maintenancePartsData });
};

const setMaintenancePartLoader = (state, { maintenancePartsLoader }) => {
  return state.merge({ maintenancePartsLoader });
};

// Maintenance Part Types
const setMaintenancePartTypes = (state, { maintenancePartTypesData }) => {
  return state.merge({ maintenancePartTypesData });
};

const setMaintenancePartTypesSearched = (state, { maintenancePartTypesSearchedData }) => {
  return state.merge({ maintenancePartTypesSearchedData });
};

const setMaintenancePartTypesSearchedLoader = (state, { maintenancePartTypesSearchedLoader }) => {
  return state.merge({ maintenancePartTypesSearchedLoader });
};

// Maintenance Types
const setMaintenanceTypesSearched = (state, { maintenanceTypesSearchedData }) => {
  return state.merge({ maintenanceTypesSearchedData });
};

const setMaintenanceTypesSearchedLoader = (state, { maintenanceTypesSearchedLoader }) => {
  return state.merge({ maintenanceTypesSearchedLoader });
};

// Maintenance Reason
const setMaintenanceReasonSearched = (state, { maintenanceReasonSearchedData }) => {
  return state.merge({ maintenanceReasonSearchedData });
};

const setMaintenanceReasonSearchedLoader = (state, { maintenanceReasonSearchedLoader }) => {
  return state.merge({ maintenanceReasonSearchedLoader });
};

// Maintenance Status
const setMaintenanceStatusSearched = (state, { maintenanceStatusSearchedData }) => {
  return state.merge({ maintenanceStatusSearchedData });
};

const setMaintenanceStatusSearchedLoader = (state, { maintenanceStatusSearchedLoader }) => {
  return state.merge({ maintenanceStatusSearchedLoader });
};

// Maintenance Job History
const setMaintenanceJobHistoryData = (state, { maintenanceJobHistoryData }) => {
  return state.merge({ maintenanceJobHistoryData });
};

const setMaintenanceJobHistoryLoader = (state, { maintenanceJobHistoryLoader }) => {
  return state.merge({ maintenanceJobHistoryLoader });
};

const setMaintenanceImagesByJob = (state, { maintenanceImagesListData }) => {
  if (!maintenanceImagesListData) return state;
  return state.merge({ maintenanceImagesListData });
};

const setMaintenanceImagesByJobLoaderStatus = (state, { maintenanceImageLoader }) => {
  return state.merge({ maintenanceImageLoader });
};

//Maintenance Job History Data Export
const setMaintenanceExportData = (state, { maintenanceJobHistoryExportData }) => {
  if (!maintenanceJobHistoryExportData) return state;
  return state.merge({ maintenanceJobHistoryExportData });
};

const setMaintenanceExportLoader = (state, { maintenanceJobHistoryExportLoader }) => {
  return state.merge({ maintenanceJobHistoryExportLoader });
};

// Maintenance Recurrence Job
const setMaintenanceRecurrenceJobsData = (state, { maintenanceRecurrenceJobsData }) => {
  return state.merge({ maintenanceRecurrenceJobsData });
};

const setMaintenanceRecurrenceJobsLoader = (state, { maintenanceRecurrenceJobsLoader }) => {
  return state.merge({ maintenanceRecurrenceJobsLoader });
};

// Maintenance Recurrence Instance
const setMaintenanceRecurrenceInstancesData = (state, { recurrenceInstanceData }) => {
  return state.merge({ recurrenceInstanceData });
};

const setMaintenanceRecurrenceInstancesLoader = (state, { recurrenceInstanceLoader }) => {
  return state.merge({ recurrenceInstanceLoader });
};

// Filters
const setMaintenanceJobFilter = (state, { addMaintenanceJob }) => {
  return state.merge({ addMaintenanceJob });
};

export const callbacks = [
  {
    actionType: ActionTypes.SET_MAINTENANCE_PARTS,
    actionFunction: setMaintenanceParts,
  },
  {
    actionType: ActionTypes.SET_MAINTENANCE_PARTS_LOADER_STATUS,
    actionFunction: setMaintenancePartLoader,
  },
  {
    actionType: ActionTypes.SET_MAINTENANCE_PART_TYPES,
    actionFunction: setMaintenancePartTypes,
  },
  {
    actionType: ActionTypes.SET_MAINTENANCE_PART_TYPES_SEARCHED,
    actionFunction: setMaintenancePartTypesSearched,
  },
  {
    actionType: ActionTypes.SET_MAINTENANCE_PART_TYPES_SEARCHED_LOADER_STATUS,
    actionFunction: setMaintenancePartTypesSearchedLoader,
  },
  {
    actionType: ActionTypes.SET_MAINTENANCE_TYPES_SEARCHED,
    actionFunction: setMaintenanceTypesSearched,
  },
  {
    actionType: ActionTypes.SET_MAINTENANCE_TYPES_SEARCHED_LOADER_STATUS,
    actionFunction: setMaintenanceTypesSearchedLoader,
  },
  {
    actionType: ActionTypes.SET_MAINTENANCE_REASON_SEARCHED,
    actionFunction: setMaintenanceReasonSearched,
  },
  {
    actionType: ActionTypes.SET_MAINTENANCE_REASON_SEARCHED_LOADER_STATUS,
    actionFunction: setMaintenanceReasonSearchedLoader,
  },
  {
    actionType: ActionTypes.SET_MAINTENANCE_STATUS_SEARCHED,
    actionFunction: setMaintenanceStatusSearched,
  },
  {
    actionType: ActionTypes.SET_MAINTENANCE_STATUS_SEARCHED_LOADER_STATUS,
    actionFunction: setMaintenanceStatusSearchedLoader,
  },
  {
    actionType: ActionTypes.SET_MAINTENANCE_JOB_HISTORY,
    actionFunction: setMaintenanceJobHistoryData,
  },
  {
    actionType: ActionTypes.SET_MAINTENANCE_JOB_HISTORY_LOADER_STATUS,
    actionFunction: setMaintenanceJobHistoryLoader,
  },
  {
    actionType: ActionTypes.SET_MAINTENANCE_IMAGES_BY_JOB,
    actionFunction: setMaintenanceImagesByJob,
  },
  {
    actionType: ActionTypes.SET_EXPORT_MAINTENANCE_JOB_HISTORY,
    actionFunction: setMaintenanceExportData,
  },
  {
    actionType: ActionTypes.EXPORT_MAINTENANCE_JOB_HISTORY_LOADER,
    actionFunction: setMaintenanceExportLoader,
  },
  {
    actionType: ActionTypes.SET_MAINTENANCE_IMAGES_BY_JOB_LOADER_STATUS,
    actionFunction: setMaintenanceImagesByJobLoaderStatus,
  },
  {
    actionType: ActionTypes.SET_MAINTENANCE_RECURRENCE_JOBS,
    actionFunction: setMaintenanceRecurrenceJobsData,
  },
  {
    actionType: ActionTypes.SET_MAINTENANCE_RECURRENCE_JOBS_LOADER_STATUS,
    actionFunction: setMaintenanceRecurrenceJobsLoader,
  },
  {
    actionType: ActionTypes.SET_MAINTENANCE_RECURRENCE_INSTANCES,
    actionFunction: setMaintenanceRecurrenceInstancesData,
  },
  {
    actionType: ActionTypes.SET_MAINTENANCE_RECURRENCE_INSTANCES_LOADER_STATUS,
    actionFunction: setMaintenanceRecurrenceInstancesLoader,
  },
  {
    actionType: ActionTypes.SET_MAINTENANCE_JOB_FILTER,
    actionFunction: setMaintenanceJobFilter,
  },
];
